import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { getUniqueId } from 'react-native-device-info';
import { EventRegister } from 'react-native-event-listeners';

const DatabaseService = {
  serverURL() {
    // return 'http://localhost:8013';
//     return 'https://cofe.aimernginx.co.uk';
    return 'https://hymns-api.hymnsam.co.uk';
  },

  async updateBookmark(email, requestToken, bookmarkId) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/userData/updateBookmark`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(bookmarkId && { BookmarkID: bookmarkId }),
          ...(requestToken && { RequestToken: requestToken }),
        };

        response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        let responseJson = await response.json();

        if (responseJson.success) {
          resolve(responseJson.body.affectedRows);
        } else {
          reject(responseJson.body);
        }
      } catch (error) {
        reject(error);
      }
    });
  },

  async updateNote(email, requestToken, note, remove) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/userData/updateNote`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(note && { Note: note }),
          ...(requestToken && { RequestToken: requestToken }),
          ...(remove && { RemoveNote: true }),
        };

        response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        });

        let responseJson = await response.json();

        if (responseJson.success) {
          resolve(responseJson.body.affectedRows);
        } else {
          reject(responseJson.body);
        }
      } catch (error) {
        reject(error);
      }
    });
  },

  async getAllBookmarks(email, requestToken) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/userData/getBookmarks`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(requestToken && { RequestToken: requestToken }),
        };

        try {
          response = await fetch(url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });
        } catch (error) {
          reject(error);
        }

        let responseJson = await response.json();

        if (responseJson.success) {
          if (responseJson.body) {
            resolve(JSON.parse(responseJson.body));
          } else {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      } catch (error) {
        console.log('getAllBookmarks', error);
        reject(null);
      }
    });
  },

  async getAllNotes(email, requestToken) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/userData/getNotes`;
        let response = null;

        const body = {
          ...(email && { Email: email }),
          ...(requestToken && { RequestToken: requestToken }),
        };

        try {
          response = await fetch(url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });
        } catch (error) {
          reject(error);
        }

        let responseJson = await response.json();

        if (responseJson.success) {
          if (responseJson.body) {
            let body = JSON.parse(responseJson.body);
            body = body && body.map((item) => ({ id: item.id, note: decodeURI(item.note) }));
            resolve(body);
          } else {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      } catch (error) {
        console.log('getAllNotes', error);
        reject(null);
      }
    });
  },

  async getFreeTrialData(UUID) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `${this.serverURL()}/lectionary/getFreeTrialData`;
        let response = null;

        const body = {
          ...(UUID && { UUID: UUID }),
          Product: 'com.aimermedia.Lectionary',
        };

        try {
          response = await fetch(url, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
          });
        } catch (error) {
          reject(error);
        }

        let responseJson = await response.json();

        if (responseJson.success) {
          if (responseJson.body) {
            resolve(responseJson.body);
          } else {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      } catch (error) {
        console.log('getFreeTrialData', error);
        reject(null);
      }
    });
  },
};

export default DatabaseService;